// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"df7f4c00","455":"791729b1","977":"0f522e23"}[chunkId] + ".chunk.js";
};